// extracted by mini-css-extract-plugin
export default {"root":"TimeRange_root__HwImA","dateSection":"TimeRange_dateSection__Fhe-C"};